import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { finalize, take } from 'rxjs/operators';

import { ApiError } from '../../../../core';
import { LocalFaturamentoCrudHttpService } from '../../../../home/local-faturamento/services';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';
import { ToastService } from '../toast/services/toast.service';

@Component({
  selector: 'sgt-novo-local-faturamento-multiselect',
  templateUrl: './novo-local-faturamento-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoLocalFaturamentoMultiselectComponent),
      multi: true,
    },
  ],
})
export class NovoLocalFaturamentoMultiselectComponent extends CustomControlValueAccessor<number[]> {
  @Input() idsLocaisFaturamentos: number[];
  @Output() idsLocaisFaturamentosChange = new EventEmitter<number[]>();

  settings: IMultiSelectSettings = {
    placeholder: 'Selecione os locais',
    plural: 'Locais de Faturamento',
    singular: 'Local de Faturamento',
    searchEmptyResultMessage: 'Nenhum local encontrado',
    showFooter: false
  };

  options: IOption[] = [];

  constructor(
    private toastService: ToastService,
    private localFaturamentoCrudHttpService: LocalFaturamentoCrudHttpService
  ) {
    super();
  }

  firstOpened(isFirstOpened: boolean): void {
    if (isFirstOpened && this.options.length === 0) {
      this.create();
    }
  }

  private create() {
    this.definirCarregando(true);

    this.localFaturamentoCrudHttpService
      .search()
      .pipe(take(1), finalize(() => this.definirCarregando(false)))
      .subscribe(
        (entities) => {
          if (entities) {
            const currentIds = this.value ?? [];
            this.options = entities.map((entity) => ({
              id: entity.id,
              label: entity.nome,
              isChecked: currentIds.includes(entity.id)
            }));
          }
        },
        (error: ApiError) =>
          this.toastService.error(error.message, {
            title: error.cause
          })
      );
  }

  protected updateValue(newValue: number[] | null): void {
    const ids = newValue ?? [];
    this.idsLocaisFaturamentos = ids;
    if (ids.length > 0 && this.options.length === 0) {
      this.create();
      return;
    }
    if (this.options.length > 0) {
      this.options.forEach((o) => {
        o.isChecked = ids.includes(o.id);
      });
    }
  }

  onSearch() {
    this.idsLocaisFaturamentosChange.emit(this.idsLocaisFaturamentos);
  }

  onSelectionChange() {
    this.emitChange(this.idsLocaisFaturamentos);
    this.markAsTouched();
  }

  private definirCarregando(carregando: boolean): void {
    this.settings = { ...this.settings, isLoading: carregando };
  }

}
